import { animate, state, style, transition, trigger } from '@angular/animations';

export const openCloseAnimation = trigger('openClose', [
  state('true', style({ height: '*', opacity: 'inherit' })),
  state('false', style({ height: '0px', opacity: 0 })),
  transition('false <=> true', animate(250)),
]);
